<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('report_price_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print"><i class="fa fa-print"></i> {{$t('print')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{ $t('item_category_list') }}</label>
                                <select class="form-control form-control-sm" v-model="query.CategoryId" @change="toList">
                                    <option value="">{{$t('all')}}</option>
                                    <option v-for="ret in categories" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <h4 class="text-center">{{$t('report_price_list')}}</h4>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                            <tr>
                                <th>{{$t('no')}}</th>
                                <th>{{$t('code')}}</th>
                                <th>{{$t('name')}}</th>
                                <th>{{$t('brand_list')}}</th>
                                <th>{{$t('category')}}</th>
                                <th>{{$t('uom')}}</th>
                                <th>{{$t('weight')}}</th>
                                <th class="text-right">{{ $t('cost') }}</th>
                                <th class="text-right">{{ $t('price_sale') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret,index) in records" :key="index">
                                <td>{{index+1}}</td>
                                <td>{{ret.Num}}</td>
                                <td>{{ret.Name}}</td>
                                <td>{{ret.BrandName}}</td>
                                <td>{{ret.CategoryName}}</td>
                                <td>{{ret.UomName}}</td>
                                <td>{{ret.Weight}}</td>
                                <td class="text-right">{{$money(ret.Cost)}}</td>
                                <td class="text-right">{{$money(ret.Price)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function () {
            return {
                query: {
                    CategoryId: '',
                    CompanyId: this.$store.state.company.Id
                },
                records: [],
                categories: []
            }
        },
        created: function () {
            this.$api().post('category/list', { CompanyId: this.$store.state.company.Id }).then(res => {
                if (this.$isValid(res)) {
                    this.categories = res.data.Json.Categories;
                }
            });
            this.toList();
        },
        methods: {
            toList() {
                let loading = this.$loading.show();
                this.$api().post("report/item/list", this.query).then(res => {
                    this.records = res.data.Json.Items;
                }).finally(function () {
                    loading.hide();
                });
            },
            print: function () {
                let params = '?t=0';
                if (this.query.CategoryId != '') {
                    params = '?t=' + this.query.CategoryId;
                }
                params += '&CompanyId=' + this.$store.state.company.Id;

                window.open("/print/price/list" + params, "_blank");
            }
        }
    };
</script>